import {
  selectInviteVerification,
  selectIsLoading,
} from "app/containers/OnBoarding/redux/selector";
import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "app/components/Button";
import EmailIcon from "app/components/Icons/EmailIcon";
import Input from "app/components/Input";
import LoaderOverlay from "app/containers/OnBoarding/containers/Team/components/LoaderOverlay";
import TitleText from "../components/TitleText";
import FooterLinks from "./Signup/FooterLinks";
import { selectIsGoogleLogin, selectSignupForm } from "../redux/selector";
import { actions } from "../redux/slice";
import useInviteHandler from "./Signup/useInviteHandler";
import google from "../../../../assets/svgs/ic_google.svg";
import { validateSignupForm } from "../helpers";

const SignUpInvite = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [googleToken, setGoogleToken] = useState<string | null>(null);
  const inviteData = useSelector(selectInviteVerification);
  const inviteLoading = useSelector(selectIsLoading);
  const form = useSelector(selectSignupForm);
  const isGoogleLogin = useSelector(selectIsGoogleLogin);

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useInviteHandler(() => {}, searchParams);

  // Google initialization
  useEffect(() => {
    /* global google */

    //@ts-ignore
    window.google?.accounts.id.initialize({
      client_id: "103899296356403251476.apps.googleusercontent.com",
      auto_select: true,
      callback: (response: any) => {
        const decoded = jwtDecode(response.credential) as any;
        setEmail(decoded.email);
        setName(decoded.name);
        setGoogleToken(response.credential);

        // Optional: dispatch Redux login
        // dispatch(
        //   actions.googleLoginRequest({
        //     token: response.credential,
        //     callback: () => navigate("/dashboard"), // redirect after success
        //   })
        // );
      },
    });
  }, [dispatch, navigate]);

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const token = searchParams.get("token");
    const errors = validateSignupForm({ email: form.email });
    if (errors.length > 0) {
      dispatch(actions.setSignupFormErrors(errors));
      return;
    }
    dispatch(
      actions.signupRequest({
        callback: () => {
          localStorage.setItem("inviteToken", token as string);
          dispatch(actions.clearSignUpForm());
          navigate("/auth/verify-email?email=" + form.email.value);
        },
      })
    );
  };

  useEffect(() => {
    if (inviteData.email) {
      dispatch(
        actions.setSignupFormValues({
          name: "email",
          value: inviteData.email,
        })
      );
    }

    return () => {};
  }, [inviteData]);

  const isDisabled = (): boolean => {
    return (
      isGoogleLogin || form.isLoading || !!form.email.error || !form.email.value
    );
  };
  const getNameFromEmail = (email: string) => {
    const namePart = email.split("@")[0];
    return namePart
      .replace(/[._]/g, " ") // replace . and _ with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
  };
  const derivedName = inviteData?.email
    ? getNameFromEmail(inviteData.email)
    : "";

  return (
    <div className="flex flex-col items-center">
      {Boolean(inviteLoading) && <LoaderOverlay />}
      <TitleText title=" Sign up to Teambox.Dev" />
      <form className="flex flex-col gap-[20px] w-full max-w-[444px] min-w-[366px] mb-[56px]">
        {/* Google button */}
        <Button
          className="w-full h-[56px] flex items-center justify-between w-full "
          type="button"
          isLoading={isGoogleLogin}
        >
          <div className="flex items-center justify-between gap-[10px] w-full ">
            <div className="flex gap-2 items-center">
              <div className="rounded-full size-7">
                {/* <img src={userImg} alt="" /> */}
              </div>
              <div className="flex flex-col text-start">
                <span className="text-white text-md font-medium">
                  Continue as {derivedName || "Guest"}
                </span>
                <span className="text-white text-sm font-normal">
                  {inviteData.email || "your Gmail"}
                </span>
              </div>
            </div>
            <img sizes="24px" src={google} alt="Google" />
          </div>
        </Button>

        {/* Email input */}
        <Input
          id="email"
          type="email"
          placeholder="Enter email address"
          icon={<EmailIcon />}
          error={form.email.error}
          value={form.email.value}
          name="email"
          disabled
          helperText="Signing up with work email makes it easier for coworkers to join your team"
        />

        <Button
          type="button"
          isLoading={form.isLoading}
          loaderClassName="border-secondary"
          disabled={isDisabled()}
          disabledClassName="opacity-50"
          className="w-full h-[56px] !border !border-secondary bg-white text-secondary mt-[10px]"
          onClick={(e) => handleSubmit(e)}
        >
          Continue with email
        </Button>
      </form>
      <FooterLinks />
    </div>
  );
};

export default SignUpInvite;
